import CoreBase from '../../../../services/engines/CoreBase';
import _service from '../../../../services/UserTopicService';
import responseHelper from '../../../../services/ResponseHelper';

const _name = 'TopicGroupLoader';

/**
 * Handles fetching group data from the backend.
 */
export default class TopicGroupLoader extends CoreBase {
    _name = _name;

    /**
     * Fetches all groups for the current user.
     * @returns {Array|null} groups if successful, null on failure
     */
    load = async () => {
        try {
            const resp = await _service.getGroups();
            const code = responseHelper.check(resp, 'load', _name);

            if (code < 0) {
                this.logError('load', `server returned code=${code}, status=${resp?.status}`);
                return null;
            }

            return resp.data.items ?? [];
        } catch (error) {
            this.logError('load', error.message);
            this.onError(error.message);
            return null;
        }
    };
}
